/* Struxa calculator - binder for the compiled Claude Design v3 markup.
   Ported from Struxa Gas Strut Calculator v3.dc.html, 03/10/2026.

   The design is a React component. The snippet is its markup compiled to
   data- hooks; this is its logic, ported, driving those hooks. Values are the
   design's own: its state defaults, its solve(), its renderVals(). That is
   deliberate - Dave asked for the page to match the design exactly first, and
   for changes to come after it does.

   Two notes for whoever changes it next:
     - solve() is the design's PROVISIONAL solver, its own word. Struxa's real
       physics (the 572N air-freight ceiling, the stock table, the verified
       torque models) lives in sx-calculator.js and should replace it. Until
       then the force and kick-in figures here are indicative.
     - the price is the design's $68. Struxa charges $75.
   Both are why this page is still noindex on an obscure handle.
*/
(function () {
  'use strict';

  var A = '#ff7a00', INK = '#1c1e22';
  var CDN = 'https://cdn.shopify.com/s/files/1/0776/7477/4628/files/';

  var S = {
    angle: 68, type: 'Box Lid', hinge: 'Top', struts: 2, qty: null, assist: 'Balanced',
    yaw: 0.62, drag: null, pw: 900, ph: 600, pd: 450, kg: 14, mount: 'Flush',
    end: 'rod', rodFit: 'socket', tubeFit: 'socket', manual: null,
    // Was 10, went to 5 on the flat-force model, and is back at 10.
    // 5 landed on 190N, which the flat sum called a 0.06kg hold at shut -
    // but a real strut is ~1.28x stiffer there on this geometry, and at a
    // 5 degree target 99% of box lids would want a catch against 86% at 10.
    // The reason for 5 does not survive the curve, so the reason is gone.
    kickSet: 10,          // degrees; the strut should take over early
    // mm DEEP the lid's own frame rail is. Bracket A bolts to its inner
    // face, so the ball ends up half that below the skin - 40mm of rail
    // is the 20mm standoff the solver was calibrated at.
    lidFrame: 40, lidFrameW: 40, lidClose: 'outside',
    // Both ends want the offset, for the same reason. Each bolts its
    // plate to a face that is SQUARE to the way the strut swings - B up
    // under the box rail, A under the lid - and a flat plate there points
    // its stud along the swing instead of across it, so the socket cannot
    // take the ball. Dave, 14/10/2026: the lid "has to be br2 and
    // vertical as the ball stud needs to line up 90 degrees".
    //
    // This comment used to say the lid bolts to a VERTICAL face and wants
    // the flat. sx-physics.js has always modelled it as the underside,
    // dropping the ball by the standoff, so the two files disagreed and
    // the physics is the one that was shipping numbers.
    brkEnd: 'box',        // which end the picker is choosing for
    bracketA: 'offset',   // on the panel
    // Under a rail this one has to be BR2 for the same reason the lid
    // does, and the default used to be flat - so adding a rail dropped
    // straight into the cannot-be-fitted branch and drew a warning
    // instead of a bracket. On an open wall either part goes on.
    bracketB: 'offset',   // on the box
    rail: 0,              // mm of frame rail down the box side, 0 = plain

    // view only. The design had ONE angle doing two jobs: the max opening
    // angle the strut is sized for, AND the position the figures are drawn
    // at - so scrubbing the playback bar silently re-sized the strut and
    // changed the recommendation. This is the position you are looking at;
    // S.angle stays the angle you are buying for.
    view: null,
    // Degrees the whole box is tilted. Positive means the hinge end sits
    // lower, so gravity helps the lid open; negative makes it fall shut
    // harder. It changes the holding torque, so it is in the maths, not
    // just the picture.
    tilt: 0
  };
  function viewAng() { return S.view == null ? S.angle : Math.min(S.view, S.angle); }

  var STOCKED = [280, 300, 320, 330, 375, 440, 460, 480, 500, 520, 540, 555, 560, 575, 580, 585];
  function sku(mm) { return 'STRUT-8-' + mm; }

  // The design's four fittings. Photos are Struxa's own product shots where
  // one exists - each was checked for a 200 before being used, because the
  // fitting a file shows lives only in its filename.
  // The end fittings offered for a box lid or a sash. Angled was dropped on
  // 12/10/2026 - Dave: "why do we offer anlged plastic soket for this when it
  // should be straight?". On a lid both ball studs point the same way and the
  // strut runs straight between them, so an angled socket has nothing to
  // correct for. It is still a Struxa part; it just is not an option here.
  // A saved link carrying rodFit=angled falls back to the default, because
  // the restore below only accepts ids that are in this list.
  var FITS = [
    { id: 'socket', sku: 'EF1', name: 'Standard plastic socket', src: CDN + 'standard-plastic-socket-10mm.jpg?width=240' },
    { id: 'small', sku: 'EF3', name: 'Small plastic socket', src: CDN + 'small-plastic-socket-10mm.jpg?width=240' },
    { id: 'metal', sku: 'EF4', name: 'Metal ball socket', src: CDN + 'metal-ball-socket-10mm.jpg?width=240' }
  ];
  // Whole-strut renders, keyed by the rod-end fitting. There is no render of
  // a strut with a loose ball stud, so that falls back to the plastic socket
  // it clips onto.
  // Whole-strut renders, keyed by BOTH ends: the filenames encode the shaft
  // fitting and the tube fitting, so there is a picture per combination. The
  // old map keyed on the rod end only, so changing the tube fitting changed
  // nothing on screen. Every URL below was fetched and returned 200 - a
  // guessed filename is not a broken image, it is the wrong part shown.
  var SOCKET_RENDER = 'Standard_20plastic_2010mm_20socket_20shaft__Standard_20plastic_2010mm_20socket_20tube_6978970b-211f-4ac1-8f79-6c16de52f69a.png';
  // The angled socket rows below are now unreachable from this calculator -
  // see the FITS list above - and are kept so the renders are still here if
  // it ever comes back. Nothing selects them.
  var STRUT_IMG = {
    'angled|angled': 'Angled_plastic_socket_10mm_shaft__Angled_plastic_socket_10mm_tube.png',
    'angled|metal': 'Angled_plastic_socket_10mm_shaft__Metal_Socket_10mm_tube.png',
    'angled|small': 'Angled_plastic_socket_10mm_shaft__Small_plastic_socket_10mm_tube.png',
    'angled|socket': 'Angled_plastic_socket_10mm_shaft__Standard_plastic_10mm_socket_tube.png',
    'eye|eye': '8mm_metal_eye_shaft__8mm_metal_eye_tube.png',
    'eye|socket': '8mm_metal_eye_shaft__Standard_plastic_10mm_socket_tube.png',
    'metal|angled': 'Metal_socket_10mm_shaft__Angled_plastic_socket_10mm_tube.png',
    'metal|metal': 'Metal_socket_10mm_shaft__Metal_Socket_10mm_tube.png',
    'metal|socket': 'Metal_socket_10mm_shaft__Standard_plastic_10mm_socket_tube.png',
    'small|angled': 'Small_plastic_socket_10mm_shaft__Angled_plastic_socket_10mm_tube.png',
    'small|eye': 'Small_plastic_socket_10mm_shaft__8mm_metal_eye_tube.png',
    'small|socket': 'Small_plastic_socket_10mm_shaft__Standard_plastic_10mm_socket_tube.png',
    'socket|angled': 'Standard_20plastic_2010mm_20socket_20shaft__Angled_20plastic_20socket_2010mm_20tube_c8c56fda-39f5-465c-bd7a-9ff98504a35c.png',
    'socket|eye': 'Standard_plastic_10mm_socket_shaft__8mm_metal_eye_tube.png',
    'socket|small': 'Standard_20plastic_2010mm_20socket_20shaft__Small_20plastic_20socket_2010mm_20tube_518e5f43-1fb2-4ece-becf-bebd2a2db46b.png',
    'socket|socket': 'Standard_20plastic_2010mm_20socket_20shaft__Standard_20plastic_2010mm_20socket_20tube_6978970b-211f-4ac1-8f79-6c16de52f69a.png'
  };

  // Not every pair has been rendered. Fall back to the same rod end with a
  // standard socket tube before giving up on standard/standard, so the rod
  // end - the one the customer is looking at - stays correct.
  function strutRender(rod, tube) {
    return STRUT_IMG[rod + '|' + tube]
        || STRUT_IMG[rod + '|socket']
        || SOCKET_RENDER;
  }

  // Struxa's two mounting brackets. Both carry a 10mm ball stud, both $10,
  // both stocked. The strut ships with a bracket kit already, so this picks
  // which pair goes in the box rather than adding to the price.
  var BRACKETS = [
    // Both parts are the same idea: a triangle with the ball stud centred
    // at the top of it. Dave, 14/10/2026: "they are triangle and in the
    // middle at the top is teh ball stud for both". The only difference is
    // which plane the triangle sits in. "Offset bracket" is the shop NAME
    // and does not describe what the part does - the note here used to say
    // it stepped the stud off the face, which is not a thing it does.
    { id: 'flat', sku: 'BR1', name: 'Flat bracket',
      note: 'Triangle lies flat, ball on top of it',
      src: CDN + 'bracket-flat-10mm-ball-stud-v2.jpg?width=240' },
    { id: 'offset', sku: 'BR2', name: 'Offset bracket',
      note: 'Triangle stands up off the plate, ball on top',
      src: CDN + 'bracket-l-shape-10mm-ball-stud-v2.jpg?width=240' }
  ];

  // The measured mounting-face-to-ball figure for the bracket the solver
  // actually used under a rail. Read from SXPHYS so this text cannot drift
  // away from the number the bracket position was computed with.
  function brkStandoffMM() {
    var P = window.SXPHYS;
    var v = P && P.BRKT_STANDOFF ? P.BRKT_STANDOFF.offset : 0.020;
    return Math.round(v * 1000);
  }

  function brktName(id) {
    var b = BRACKETS.filter(function (x) { return x.id === id; })[0];
    return b ? b.name : '';
  }

  function fitName(id) { var f = FITS.filter(function (x) { return x.id === id; })[0]; return f ? f.name : ''; }

  // ── the real solver ───────────────────────────────────────────────────────
  // The design shipped a provisional one - its own word - and it was a long way
  // out: for a 14kg 450mm lid it asked for 80 N where the real maths asks for
  // 200. sx-physics.js is Struxa's verified solver, so the numbers on this page
  // are the numbers the strut has to deliver.
  // Kick-in is the angle the strut starts carrying the panel. It used to be
  // a Light/Balanced/Firm preset that worked out at 70/45/20% of the swing -
  // so 'Balanced' meant lifting a lid halfway by hand before it did anything.
  // It is a direct input now. Low is better and costs more force, which the
  // solver sizes for; 5 degree steps because finer than that is false
  // precision on a hand-fitted bracket.
  var KICK_MIN = 5, KICK_MAX = 45, KICK_STEP = 5;

  // ignoreManual=true solves as if nothing had been overridden, which is how
  // the "our best fit is X" line still knows what X is.
  function solve(ignoreManual) {
    var P = window.SXPHYS;
    var st = P.state;
    st.pinLen = ignoreManual ? null : (Number(S.manual) || null);
    var isLid = S.type === 'Box Lid';
    st.type = isLid ? 'box_lid' : 'top_hinge';
    // Clamped to the same limits the sliders carry. An input attribute only
    // stops typing; a pasted or restored value still reaches here, and a
    // negative dimension renders a negative millimetre on screen.
    var lim = function (v, lo, hi, dflt) {
      v = Number(v);
      if (!isFinite(v) || v <= 0) { return dflt; }
      return Math.max(lo, Math.min(hi, v));
    };
    st.w = lim(S.kg, 0.5, 40, 0.5);
    st.l = lim(isLid ? S.pd : S.ph, 100, 1200, 100);  // what the lid swings through
    st.wd = lim(S.pw, 200, 1500, 200);
    st.bh = lim(S.ph, 150, 1200, 150);                // box wall height
    st.t = 18;                                   // no thickness input in v3; stock lid material
    st.ns = S.struts;
    st.oa = Number(S.angle) || 90;
    st.tilt = Number(S.tilt) || 0;
    // Opening assist is how early the strut takes over, which is exactly what
    // the solver's hold-range start means.
    st.soa = Math.max(KICK_MIN, Math.min(S.kickSet, Math.min(KICK_MAX, st.oa)));
    st.hingem = S.mount === 'Overlay' ? 'overlay' : S.mount === 'Inside face' ? 'inside' : 'flush';
    st.lidFrame = Number(S.lidFrame);
    // Width decides whether the 20mm plate fits the frame's underside.
    st.lidFrameW = Number(S.lidFrameW);
    st.lidClose = S.lidClose;
    st.rail = Number(S.rail);
    // The bracket choice used to stop at the kit line and the order
    // property. Under a rail it decides how far the ball hangs below it.
    st.brkA = S.bracketA;
    st.brkB = S.bracketB;

    var r = P.calcP();
    var ext = r.recLen || 0;
    return {
      Lp: st.l / 1000,
      ext: ext,
      stroke: ext && r.compLen ? ext - r.compLen : 0,
      kick: r.soAng == null ? 0 : r.soAng,
      // The wrapper folds a null kick-in into 0, and 0 also means "already
      // beats gravity at fully shut". Keep them apart.
      kickRaw: r.soAng,
      force: r.recF || 0,
      // What the statics asked for, before the 100N the product form
      // floors at. Below that, the floor is setting the force.
      needF: r.needF || 0,
      // what the hand carries before the strut takes over, at the panel edge
      liftF: r.liftF || 0,
      latchF: r.latchF || 0,
      // the same check against a real strut's force curve at the shut
      // position, which is where it is stiffest - see P2_P1 in sx-physics
      latchReal: r.latchReal || 0,
      noFit: !!r.noFit,
      // a rail too deep to leave solid box side below it
      railFoul: !!r.railFoul,
      stock: r.struxaStock,
      compLen: r.compLen,
      // bracket positions, in mm, straight from the solver
      ballDrop: r.lidFrame || 0,
      a: (r.a || 0) * 1000,
      b: Math.abs((r.Bx || 0) * 1000),
      c: Math.abs((r.By || 0) * 1000)
    };
  }

  var seg = function (on) { return on ? INK : '#fff'; };
  var segF = function (on) { return on ? '#fff' : '#6e6e6b'; };
  var sel = function (on) { return on ? '#17171a' : '#e0e0db'; };
  var shd = function (on) { return on ? '4px 4px 0 #17171a' : 'none'; };
  var mm = function (v) { return Math.round(v) + ' mm'; };

  // Strut length at every degree of the swing, from the solver's own sweep.
  // This used to be a SECOND guess at the geometry - bracket B at 0.30 of the
  // panel and 0.25 below, where the solver says 27mm and 70mm - so the
  // fitting sheet's "mm out" caption read 148mm on the default box where the
  // strut really moves 77mm. One source of truth.
  function sweepMM() {
    solve();                       // pushes the current inputs into the solver
    var r = window.SXPHYS.calcP();
    return (r.data || []).map(function (p) { return p.sl * 1000; });
  }

  function extAt(sl, ang) {
    if (!sl.length) { return 0; }
    var i = Math.max(0, Math.min(sl.length - 1, Math.round(ang)));
    return Math.round(sl[i] - sl[0]);
  }

  var _kick = null;   // last solved hand-over angle, for the figures

  function vals() {
    // Recommendation first, then the pinned solve, so the physics module is
    // left holding the state that matches what the customer is buying - every
    // later solve() and calcP() in this render reads it.
    var rec = solve(true);
    var r = S.manual ? solve() : rec;
    _kick = r.kick;
    // The solver already picks a REAL stocked length, tested for binding and
    // over-extension. No rounding to the nearest shelf item here.
    var nearest = rec.ext || STOCKED[0];
    // What is actually being supplied. Not S.manual: if the pinned length
    // cannot do the job, r.ext is 0, ok goes false, and the panel says so
    // rather than quoting a length against another strut's numbers.
    var pick = r.ext || nearest;
    var ok = !r.noFit && !!r.ext;
    var qty = S.qty == null ? S.struts : S.qty;
    var wide = S.pw > 700 && S.struts === 1;

    return {
      typeNote: S.type === 'Window' ? 'Top-hinged sash swinging outward.' : 'Top-hinged lid lifting up and back.',
      isBoxLid: S.type === 'Box Lid', isWindow: S.type === 'Window', isHatch: false,
      tLidBg: seg(S.type === 'Box Lid'), tLidFg: segF(S.type === 'Box Lid'),
      tWinBg: seg(S.type === 'Window'), tWinFg: segF(S.type === 'Window'),
      tHatBg: seg(false), tHatFg: segF(false),
      lcOutBg: seg(S.lidClose !== 'inside'), lcOutFg: segF(S.lidClose !== 'inside'),
      lcInBg: seg(S.lidClose === 'inside'), lcInFg: segF(S.lidClose === 'inside'),
      // The frame sliders only mean anything when the lid drops inside.
      lidInset: S.lidClose === 'inside',
      s1Bg: seg(S.struts === 1), s1Fg: segF(S.struts === 1),
      s2Bg: seg(S.struts === 2), s2Fg: segF(S.struts === 2),
      strutTip: wide ? 'Over 700mm wide: use two so the panel stays square.'
        : 'Two struts share the load. Use two on anything over 700mm wide.',
      strutTipColor: wide ? '#c25a00' : '#8a8a86',
      aLBg: seg(S.assist === 'Light'), aLFg: segF(S.assist === 'Light'),
      aBBg: seg(S.assist === 'Balanced'), aBFg: segF(S.assist === 'Balanced'),
      aFBg: seg(S.assist === 'Firm'), aFFg: segF(S.assist === 'Firm'),
      assistNote: S.assist === 'Light' ? 'You lift most of the way, the strut finishes it.'
        : S.assist === 'Firm' ? 'Pops open with a small lift. Needs a firm pull to close.'
          : 'Lift it part way and it carries on by itself.',
      mFlushBorder: sel(S.mount === 'Flush'), mFlushShadow: shd(S.mount === 'Flush'),
      mOverBorder: sel(S.mount === 'Overlay'), mOverShadow: shd(S.mount === 'Overlay'),
      mInBorder: sel(S.mount === 'Inside face'), mInShadow: shd(S.mount === 'Inside face'),
      mountNote: S.mount === 'Overlay' ? 'Panel closes on top of the frame, covering its edges.'
        : S.mount === 'Inside face' ? 'Hinge on the inner wall, panel set back from the face.'
          : 'Panel sits inside the opening, level with the frame.',
      hLabel: S.type === 'Box Lid' ? 'Box height' : 'Height',
      dimsLabel: S.pw + ' × ' + (S.type === 'Box Lid' ? S.pd : S.ph) + ' mm · ' + S.kg + ' kg',
      angle: S.angle, angleLabel: S.angle + '°',
      viewAngle: viewAng(),
      // so the printed sheet can flag the note instead of just stating it
      mountWarn: !!r.railFoul,
      aMM: r.a, bMM: r.b, cMM: r.c,
      // Height only moves the answer on a shallow box: bracket B sits
      // max(min(70mm, height*0.30), 30mm) below the hinge, which is a flat
      // 70mm for anything over 234mm.
      heightNote: (Number(S.ph) || 0) < 240
        ? 'Shallow box, so bracket B has to sit higher than usual - the '
          + 'strut is sized for it.'
        : 'Above 240mm the height does not change the strut. It sets how '
          + 'far down the side bracket B can go.',
      // The two sliders carry data-bind-value, so the model has to publish
      // the raw numbers as well as their labels. It did not, so the thumbs
      // never moved when anything set them from code - restoring a saved box
      // put 60mm on the label and left the slider sitting at None.
      lidFrame: Number(S.lidFrame),
      rail: Number(S.rail),
      // A window has no box. Same sliders, the right words in front of them.
      // 03 since the swing section moved above this one. The other two
      // numbers live in build_snippet.py - keep them in step.
      boxSecTitle: S.type === 'Box Lid' ? '03 / Your box' : '03 / Your frame',
      lidFrameTitle: S.type === 'Box Lid' ? 'Lid frame depth' : 'Sash frame depth',
      lidFrameWTitle: S.type === 'Box Lid' ? 'Lid frame width' : 'Sash frame width',
      lidFrameWLabel: Number(S.lidFrameW) < 1 ? 'None' : S.lidFrameW + 'mm',
      // The plate is 20mm across. Narrower than that and there is nothing
      // to bolt it to, so the solver treats the lid as flat - say so here
      // rather than letting the answer quietly change.
      lidFrameWNote: (Number(S.lidFrame) > 0 && Number(S.lidFrameW) < 20)
        ? 'That frame is too narrow for the bracket base, which is 20mm '
          + 'across. Worked out as a flat lid instead.'
        : '',
      railTitle: S.type === 'Box Lid' ? 'Box frame rail' : 'Frame rail',
      lidFrameLabel: Number(S.lidFrame) < 10 ? 'Flat lid' : S.lidFrame + 'mm',
      // what that rail actually does to the ball, so the two cannot be
      // confused the way they were when one number did both jobs
      ballDrop: r.ballDrop || 0,
      railLabel: Number(S.rail) === 0 ? 'None' : S.rail + 'mm',
      // Bracket B is solved to sit below the rail, which needs less force
      // than the standard 70mm, not more - so this is advice, not a warning.
      mountNote: (function () {
        var d = Math.round(r.c || 0);
        if (r.railFoul) {
          return 'A ' + S.rail + 'mm rail on a box this shallow leaves nowhere '
            + 'for bracket B to go. Talk to us before you drill anything.';
        }
        // A window is solved differently and must be described
        // differently. The window branch never reads the sash rail: there is
        // no ball-standoff term in it at all. Bracket A sits at the end of
        // the sash and bracket B is set BACK behind the hinge line, which is
        // what stops the linkage going dead mid-swing. Describing it as a
        // box lid told somebody to drill somewhere the solver had not
        // solved for.
        if (S.type !== 'Box Lid') {
          return 'Bracket A bolts to the sash, ' + Math.round(r.a || 0)
            + 'mm from the hinge along it. Bracket B goes on the frame, '
            + Math.round(r.b || 0) + 'mm back behind the hinge line and '
            + d + 'mm below it. Set back is deliberate - in line, the strut '
            + 'and the sash would go dead partway through the swing.';
        }
        var panelWord = S.type === 'Box Lid' ? 'lid' : 'sash';
        // Which surface bracket A meets depends on how the panel closes. Over
        // the outside its frame never enters the box, so the bracket goes
        // straight on the skin and the frame is not part of the sentence at
        // all - saying "your 40mm lid rail" there describes a part the strut
        // never touches. Dropping inside, the frame is what it bolts under.
        var lid = (S.lidClose !== 'inside' || Number(S.lidFrame) < 10)
          ? 'Bracket A bolts flat to the underside of the ' + panelWord
            + ' itself, stud pointing down into the box. That puts the ball '
            + (r.ballDrop || 0) + 'mm below the skin. '
          : 'Bracket A bolts flat to the underside of your ' + S.lidFrame + 'mm '
            + panelWord + ' frame, stud pointing down into the box'
            + '. That puts the ball ' + (r.ballDrop || 0)
            + 'mm below the skin. ';
        if (Number(S.rail) > 0) {
          // On a framed box B does NOT go on the side wall: the rail stands
          // proud of it and the strut would hit the rail. It bolts under the
          // rail with the stud pointing inboard, which is what puts the ball
          // at rail depth plus the bracket below the hinge line.
          return lid + 'Use the OFFSET bracket on the box: bolted up under a '
            + 'rail, a flat one would point its stud straight down. '
            + 'Bracket B bolts to the UNDERSIDE of your ' + S.rail
            + 'mm side rail, ball stud pointing in towards the middle of the '
            + 'box. The bracket hangs its own ' + brkStandoffMM() + 'mm below '
            + 'the rail, so the ball ends up ' + d + 'mm under the hinge line - '
            + Math.round(Number(S.rail)) + 'mm of rail plus ' + brkStandoffMM()
            + 'mm of bracket, not ' + Math.round(Number(S.rail)) + 'mm. Not on '
            + 'the box side wall - the strut would hit the rail.';
        }
        return lid + 'Bracket B goes ' + d + 'mm below the hinge line on the '
          + 'box side.';
      })(),
      kickSet: S.kickSet,
      kickSetLabel: S.kickSet + '\u00b0',
      // A hand-over angle on its own tells nobody anything. What they want
      // to know is how heavy it is until then, and whether it stays shut.
      kickNote: (function () {
        var kg = function (nn) { return (nn / 9.81).toFixed(nn < 20 ? 1 : 0); };
        if (!ok) {
          return 'Earlier means less lifting by hand and a firmer strut; '
            + 'later means more lifting and a softer one.';
        }
        // latchReal, not latchF. latchF is the sum against the ideal force;
        // latchReal is the same sum against a real strut at its shut length,
        // including the stiffening a gas spring has near full compression.
        // The second is what a hand actually meets.
        var hold = r.latchReal > 0 ? r.latchReal : r.latchF;
        if (hold > 0) {
          return 'The strut carries it from fully shut, so it will not stay '
            + 'closed on its own and the box needs a catch. Pushing it shut '
            + 'takes about ' + kg(hold) + 'kg at the front edge.';
        }
        var lift = r.liftF > 0 ? kg(r.liftF) + 'kg at the edge of the panel'
                               : 'almost nothing';
        return 'Lift it to ' + (r.kick || 0) + '\u00b0 - about ' + lift
          + ' - and the strut takes it from there. Earlier means less lifting '
          + 'and a firmer strut; later means more lifting and a softer one.';
      })(),
      tilt: S.tilt,
      tiltLabel: (S.tilt > 0 ? '+' : '') + S.tilt + '\u00b0',
      tiltNote: S.tilt === 0 ? 'Box is level.'
        : S.tilt > 0 ? 'Hinge end sits lower, so gravity helps it open and the strut holds less.'
        : 'Hinge end sits higher, so it falls shut harder and the strut has to hold more.',
      // The bar is a way to watch the panel move, not a figure to read, so
      // it names what is happening rather than quoting a number that
      // competes with the stroke already stated in the product panel.
      strokeLabel: viewAng() <= 0 ? 'Closed'
        : viewAng() >= S.angle ? 'Fully open'
        : (viewAng() < r.kick ? 'Opening by hand' : 'Strut holding it'),
      strokePos: viewAng() + '° of ' + S.angle + '°',
      pw: S.pw, ph: S.ph, pd: S.pd, kg: S.kg,
      figCaption: 'Fig. 01 / ' + (SXFIG.geom(st()).view === 'plan' ? 'Plan view' : 'Side view'),
      dims: [
        { k: 'A', label: 'Hinge to bracket A, along the panel', val: Math.round(r.a) + ' mm' },
        { k: 'B', label: 'Bracket B forward from the hinge', val: Math.round(r.b) + ' mm' },
        // With a rail, C is NOT the rail depth - it is the rail plus the
        // bracket's own step below it. Printing 40mm against a header that
        // says "frame rail 20mm" reads as a contradiction unless the sum is
        // shown. On a bare wall there is nothing to break down.
        { k: 'C',
          label: (Number(S.rail) > 0 && brkStandoffMM() > 0)
            ? 'Bracket B below the hinge line (' + Math.round(Number(S.rail))
              + 'mm rail + ' + brkStandoffMM() + 'mm bracket)'
            : 'Bracket B below the hinge line',
          val: Math.round(r.c) + ' mm' }
      ],
      resultEyebrow: S.manual ? 'Your pick' : ok ? 'Best fit for your panel' : 'No stocked length fits',
      resultVariant: ok ? pick + 'mm' : '—',
      // Was a hardcoded ' · in stock'. 575mm is a real variant with qty 0,
      // so this line called it in stock while the Availability row two lines
      // down correctly said otherwise.
      resultSku: ok
        ? 'SKU ' + sku(pick) + (r.stock > 0 ? ' · in stock' : ' · made to order')
        : 'Contact us for a custom length',
      specs: [
        { label: 'Install length', val: ok ? pick + ' mm' : '—', color: A },
        // Dashes, not numbers, when nothing fits. These used to print
        // "0 mm" and a kick angle beside "Outside our range" - figures
        // from a solve that produced no strut, sitting next to an install
        // length that correctly said it had nothing to report.
        { label: 'Stroke', val: ok ? mm(r.stroke) : '—', color: '#fff' },
        { label: 'Kicks in at', val: ok ? r.kick + '°' : '—', color: '#fff' },
        // Force is Struxa's own working - it is the number a competitor needs
        // to copy the part. The customer is buying a strut that fits, not a
        // spec sheet, so they get the stock position instead.
        { label: 'Availability',
          // No-fit is always a size problem, never a weight one - a 0.3kg
          // lid at 450mm solves fine, and raising a failing case to 30kg
          // never rescues it. Name the real cause rather than 'Ask us'.
          val: r.noFit ? 'Outside our range'
            // Every length offered here is one we stock, so a zero is
            // temporary rather than bespoke. 'Made to order' read as
            // 'we will build you one' and invited a wait; the notify
            // modal in layout/theme.liquid is on this page already.
            : (r.stock > 0 ? 'In stock' : 'Notify when in stock'),
          color: '#fff' }
      ],
      eRodBg: seg(S.end === 'rod'), eRodFg: segF(S.end === 'rod'),
      eTubeBg: seg(S.end === 'tube'), eTubeFg: segF(S.end === 'tube'),
      // A ball stud stands perpendicular to its plate, so the surface
      // decides the bracket. Bolted up under a horizontal box rail a flat
      // one points its stud at the floor and the strut will not go on. The
      // choice stays theirs; it just stops being an unmarked coin toss.
      bLidBg: seg(S.brkEnd === 'lid'), bLidFg: segF(S.brkEnd === 'lid'),
      bBoxBg: seg(S.brkEnd === 'box'), bBoxFg: segF(S.brkEnd === 'box'),
      // A ball stud stands perpendicular to its plate, so the SURFACE picks
      // the bracket, and the two ends are different surfaces. Only the box
      // end under a rail is a horizontal face, and that is the one case a
      // flat bracket cannot serve.
      brackets: BRACKETS.map(function (b) {
        var onBox = S.brkEnd === 'box';
        var on = (onBox ? S.bracketB : S.bracketA) === b.id;
        var needsOffset = onBox && Number(S.rail) > 0;
        var note = b.note;
        if (needsOffset && b.id === 'offset') {
          note = 'Its triangle stands the ball clear of the plate - the one '
            + 'your box rail needs';
        } else if (needsOffset && b.id === 'flat') {
          note = 'Under a rail this points the stud at the floor';
        } else if (!onBox && b.id === 'flat' && Number(S.lidFrame) >= 10) {
          note = 'Bolts flat to the lid rail face, stud straight across';
        }
        return {
          name: b.name, note: note, _id: b.id,
          bgImg: 'url("' + b.src + '")',
          border: on ? '#17171a' : (needsOffset && b.id === 'offset' ? A : '#e0e0db'),
          shadow: shd(on)
        };
      }),
      fittings: FITS.map(function (f) {
        var onRod = S.rodFit === f.id, onTube = S.tubeFit === f.id;
        var active = S.end === 'rod' ? onRod : onTube;
        return {
          name: f.name, bgImg: f.src ? 'url("' + f.src + '")' : 'none', slotId: 'fit-' + f.id,
          hasPhoto: !!f.src, noPhoto: !f.src,
          tag: onRod && onTube ? 'ROD + TUBE' : onRod ? 'ROD · B' : onTube ? 'TUBE · A' : ' ',
          border: active ? '#17171a' : (onRod || onTube ? '#8a8a86' : '#e0e0db'),
          shadow: shd(active), _id: f.id
        };
      }),
      // The strut as it will actually arrive. Every url was checked for a 200;
      // the fitting a file shows lives only in its filename, so a guessed name
      // is not a broken image, it is the wrong part shown to a buyer.
      strutImg: 'url("' + CDN + strutRender(S.rodFit, S.tubeFit) + '?width=320")',
      // Nine of the twenty-five pairs have never been rendered, so the
      // fallback shows a standard socket tube. That keeps the rod end
      // right, but the picture then claims a tube end nobody picked.
      strutNoteShow: STRUT_IMG[S.rodFit + '|' + S.tubeFit] ? 'none' : 'block',
      strutImgNote: STRUT_IMG[S.rodFit + '|' + S.tubeFit] ? ''
        : 'Photo shows a standard socket tube end. We have not photographed this pair yet - you will get the one you picked.',
      // The smallest strut we press is 100N. On a light lid that is more
      // than the statics ask for: it will hold open easily, it is staying
      // shut that gets harder. No number in the line - the force is ours.
      // Two ways a lid ends up over-sprung, and the same consequence. A
      // kick-in of zero means the strut already beats gravity at fully shut,
      // so the lid pushes itself open; a requirement under the 100N floor
      // means the smallest strut we press is more than it needs. Neither
      // line carries a number - the force is ours.
      lightShow: (ok && (r.kickRaw === 0 || (r.needF && r.needF < 95)))
        ? 'block' : 'none',
      lightNote: !ok ? ''
        : r.kickRaw === 0
          ? 'At this size the strut carries the lid from fully shut, so it '
            + 'will push itself open. Fit a catch, or open it less far.'
          : 'This lid is light enough that our smallest strut is more than it '
            + 'needs. It will hold open easily, but it may want a catch to '
            + 'stay shut.',
      qty: qty,
      // Outside our range there is no price to show and nothing to add.
      // A black button over $150.00 that does nothing when clicked is worse
      // than no button, so both say what is actually going on.
      priceLabel: ok ? '$' + (75 * qty).toFixed(2) : 'Ask us',
      priceNote: ok ? qty + ' × $75.00 incl. GST'
                    : 'Custom length, quoted to order',
      cartLabel: ok ? 'Add to Cart' : 'Ask us about this one',
      cartBg: ok ? '#17171a' : '#55555a',
      qtyLine: 'Kit included: ' + brktName(S.bracketA) + ' on the panel, '
        + brktName(S.bracketB) + ' on the box. Rod: '
        + fitName(S.rodFit) + ' · Tube: ' + fitName(S.tubeFit) + '.',
      // Arrangements that cannot be assembled at all: a flat plate bolted
      // to a face square to the strut's swing points its stud along the
      // swing, and the socket will not go over the ball. That is true
      // under a box rail and it is equally true under the lid - the
      // solver's own comment calls A "the same arrangement as bracket B
      // under the box rail" - but only the box end was ever warned about.
      brktWarnShow: ((Number(S.rail) > 0 && S.bracketB === 'flat')
                     || S.bracketA === 'flat') ? 'block' : 'none',
      brktWarn: (S.bracketA === 'flat'
        ? 'Bracket A bolts up under the lid, so a flat bracket would point '
          + 'its stud straight down and the strut will not go on. Switch the '
          + 'LID end to the offset bracket. '
        : '')
        + ((Number(S.rail) > 0 && S.bracketB === 'flat')
        ? 'Your box has a rail, so bracket B bolts up under it - a flat '
          + 'bracket would point its stud straight down and the strut will not '
          + 'go on. Switch the BOX end to the offset bracket.'
        : ''),
      // The three nearest to what is on screen, plus the recommendation
      // itself whenever it has been overridden. Without that last part the
      // override note said "pick it above to go back" while pointing at a
      // length that was not in the row: on a 585mm override the row offered
      // 560, 575 and 580, and the best fit of 375mm appeared nowhere.
      alts: (function () {
        // Centred on what the customer ASKED for, not on what is being
        // supplied. Those differ when a pinned length cannot do the job:
        // pick falls back to the recommendation, and centring on that put
        // the row three lengths away from the number they had typed.
        var want = Number(S.manual) || nearest;
        var near = STOCKED.filter(function (x) { return x !== want; })
          .sort(function (a, b) { return Math.abs(a - want) - Math.abs(b - want); })
          .slice(0, 3);
        // The override note says "pick it above to go back", so the
        // recommendation has to actually be in the row. It was not: on a
        // 585mm override the row offered 560, 575 and 580, and the best fit
        // of 375mm appeared nowhere, whether or not 585 solved.
        if (S.manual && nearest !== want && near.indexOf(nearest) < 0) {
          near.pop();
          near.push(nearest);
        }
        return near.sort(function (a, b) { return a - b; })
          .map(function (x) {
            return {
              label: x + 'mm',
              note: x === nearest && x !== want ? 'our best fit'
                : x < want ? (want - x) + 'mm shorter' : (x - want) + 'mm longer',
              _pick: x
            };
          });
      })(),
      lengths: STOCKED.map(function (x) {
        return {
          label: x, _pick: x === nearest ? null : x,
          bg: x === pick ? '#17171a' : '#fff', fg: x === pick ? '#fff' : INK,
          border: x === pick ? '#17171a' : (x === nearest ? A : '#d6d6d2')
        };
      }),
      // Only speak up when they have actually overridden; otherwise the
      // alternatives row explains itself.
      overrideNote: S.manual
        ? 'You picked ' + S.manual + 'mm. Our best fit is ' + nearest + 'mm - pick it above to go back.'
        : ''
    };
  }

  function st() {
    var r = solve();
    return { ang: viewAng(), maxAng: S.angle, kick: _kick,
      type: S.type === 'Box Lid' ? 'box_lid' : 'top_hinge',
      hinge: S.hinge, ns: S.struts, yaw: S.yaw, tilt: S.tilt,
      // millimetres, so the figure can place brackets where the solver put them
      panelLen: Number(S.type === 'Box Lid' ? S.pd : S.ph) || 450,
      boxH: Number(S.ph) || 300,
      aMM: r.a, bMM: r.b, cMM: r.c,
      // So the box can be drawn with its rail, and bracket B visibly
      // under it. A slider cannot explain what a rail is; a picture can.
      railMM: Number(S.rail) || 0,
      // Fig.04 draws both mounts in section from the real depths
      // Split by how the lid closes. A frame only sits INSIDE the box
      // when the lid drops into the opening; when the lid wraps the box
      // its skirt is outside the walls, where it never meets the strut.
      // Handing the figure one number made it draw a frame in the box on
      // every setting, including the ones the solver ignores.
      lidRailMM: (S.lidClose === 'inside' ? Number(S.lidFrame) : 0) || 0,
      lidSkirtMM: (S.lidClose === 'inside' ? 0 : Number(S.lidFrame)) || 0,
      ballDropMM: r.ballDrop || 0,
      brkA: S.bracketA, brkB: S.bracketB };
  }

  // ── apply values to the compiled hooks ────────────────────────────────────
  var root;
  function q(sel) { return [].slice.call(root.querySelectorAll(sel)); }

  function fillTpl(tpl, item) {
    var n = tpl.cloneNode(true);
    // querySelectorAll NEVER returns the node it is called on, and here the
    // row root is itself a hooked element: each end-fitting button carries
    // data-act, data-style and data-sx on the button. So every binding on a
    // row root quietly did nothing.
    //
    // It fails invisibly because an unfired style binding leaves the literal
    // `inherit` in the style attribute, and `inherit` is a real CSS value.
    // `border:1px solid inherit` takes the parent's border colour, which
    // computed to black, so all four fitting buttons drew the same black
    // border that marks the SELECTED one - and nothing threw.
    function hooked(sel) {
      var list = [].slice.call(n.querySelectorAll(sel));
      if (n.matches && n.matches(sel)) { list.unshift(n); }
      return list;
    }
    hooked('[data-sx]').forEach(function (e) {
      var k = e.getAttribute('data-sx');
      if (k.indexOf('item.') === 0) e.textContent = item[k.slice(5)];
    });
    hooked('[data-style]').forEach(function (e) { applyStyle(e, item, true); });
    hooked('[data-if]').forEach(function (e) {
      var k = e.getAttribute('data-if');
      if (k.indexOf('item.') === 0) e.style.display = item[k.slice(5)] ? '' : 'none';
    });
    return n;
  }

  // style bindings are recorded as a comma list in source order; the compiled
  // declarations they belong to were replaced with `inherit`, so they are put
  // back positionally.
  function applyStyle(el, src, isItem) {
    var keys = el.getAttribute('data-style').split(',');
    var css = el.getAttribute('style') || '';
    var i = 0;
    css = css.replace(/inherit/g, function () {
      var k = keys[i++]; if (!k) return 'inherit';
      if (isItem && k.indexOf('item.') === 0) k = k.slice(5);
      var v = isItem ? src[k] : src[k];
      return v == null ? 'inherit' : v;
    });
    el.setAttribute('style', css);
  }

  function render() {
    var V = vals();
    q('[data-sx]').forEach(function (e) {
      if (e.closest('template')) return;
      var k = e.getAttribute('data-sx');
      if (k.indexOf('item.') === 0) return;
      if (V[k] != null) e.textContent = V[k];
    });
    q('[data-bind-value]').forEach(function (e) {
      var k = e.getAttribute('data-bind-value');
      if (V[k] != null && document.activeElement !== e) e.value = V[k];
    });
    saveState();
    q('[data-style]').forEach(function (e) {
      if (e.closest('template')) return;
      if (!e.__css) e.__css = e.getAttribute('style') || '';
      e.setAttribute('style', e.__css);
      applyStyle(e, V, false);
    });
    q('[data-if]').forEach(function (e) {
      if (e.closest('template')) return;
      var k = e.getAttribute('data-if');
      if (k.indexOf('item.') === 0) return;
      e.style.display = V[k] ? '' : 'none';   // '' falls back to display:contents
    });
    q('[data-list]').forEach(function (host) {
      var name = host.getAttribute('data-list');
      var tpl = root.querySelector('[data-tpl="' + name + '"]');
      var rows = V[name] || [];
      if (!tpl) return;
      host.innerHTML = '';
      rows.forEach(function (item, i) {
        var n = fillTpl(tpl.content.firstElementChild, item);
        n.__row = item; n.__list = name; n.__i = i;
        host.appendChild(n);
      });
    });
    draw();
  }

  function draw() {
    var a = document.getElementById('sx-ref2d'), b = document.getElementById('sx-ref3d');
    if (a && a.clientWidth) SXFIG.draw2d(a, st());
    if (b && b.clientWidth) SXFIG.draw3d(b, st());
    var mo = document.getElementById('sx-refmount');
    if (mo && mo.clientWidth) SXFIG.drawMounts(mo, st());
    var d = document.getElementById('sx-refdrill');
    if (d && d.clientWidth) {
      var r = solve();
      SXFIG.drawDrill(d, {
        maxAng: S.angle, tilt: S.tilt,
        panelLen: Number(S.type === 'Box Lid' ? S.pd : S.ph) || 450,
        boxH: Number(S.ph) || 300,
        a: r.a, b: r.b, c: r.c,
        lidRail: Number(S.lidFrame) || 0, ballDrop: r.ballDrop || 0,
        // The rail is the reason B sits where it does, so the sheet someone
        // drills off has to show it.
        rail: Number(S.rail) || 0
      });
    }
  }

  // ── handlers, named exactly as the design names them ──────────────────────
  var ACT = {
    // The button had no handler at all: no data-act, no form, no link. Every
    // click did nothing. sxCartUrl needs SX_VARIANTS, which the snippet now
    // emits from the product in Liquid.
    addCart: function () {
      var r = solve();
      var P = window.SXPHYS;
      // Nothing to add outside the range. Send them to the people who can
      // quote it rather than swallowing the click.
      if (r.noFit || !r.ext) { window.location.href = '/pages/contact'; return; }
      if (!P || !P.cartUrl || typeof SX_VARIANTS === 'undefined') { return; }
      var url = P.cartUrl(r.ext, r.force, (S.qty || S.struts || 1),
                          fitName(S.rodFit) + ' / ' + fitName(S.tubeFit));
      if (!url) { return; }
      url += '&properties' + encodeURIComponent('[Brackets]')
           + '=' + encodeURIComponent(brktName(S.bracketA) + ' on the panel / '
                                    + brktName(S.bracketB) + ' on the box');
      window.location.href = url;
    },
    setBoxLidType: function () { S.type = 'Box Lid'; S.hinge = 'Top'; S.manual = null; },
    setWindowType: function () { S.type = 'Window'; S.hinge = 'Top'; S.manual = null; },
    // Over the outside is the common case: a toolbox or ute box lid
    // wraps the walls, so its frame never enters the box and the strut
    // never meets it. Dropping inside puts the frame in the way.
    setLidOutside: function () { S.lidClose = 'outside'; },
    setLidInside: function () { S.lidClose = 'inside'; },
    setOne: function () { S.struts = 1; S.qty = null; },
    setTwo: function () { S.struts = 2; S.qty = null; },
    setLight: function () { S.assist = 'Light'; },
    setBal: function () { S.assist = 'Balanced'; },
    setFirm: function () { S.assist = 'Firm'; },
    pickFlush: function () { S.mount = 'Flush'; },
    pickOverlay: function () { S.mount = 'Overlay'; },
    pickInside: function () { S.mount = 'Inside face'; },
    brkLid: function () { S.brkEnd = 'lid'; },
    brkBox: function () { S.brkEnd = 'box'; },
    endRod: function () { S.end = 'rod'; },
    endTube: function () { S.end = 'tube'; },
    qtyDown: function () { S.qty = Math.max(1, (S.qty == null ? S.struts : S.qty) - 1); },
    qtyUp: function () { S.qty = (S.qty == null ? S.struts : S.qty) + 1; },
    spinLeft: function () { S.yaw -= 0.3; },
    spinRight: function () { S.yaw += 0.3; },
    // Playback. The design has no way to watch the lid move; the old page did,
    // and it is the quickest way to see whether a strut behaves.
    anim: function () {
      var b = document.getElementById('sx-anim');
      if (T.iv) { clearInterval(T.iv); T.iv = null; if (b) b.innerHTML = '▶ Animate'; return; }
      if (b) b.innerHTML = '⏸ Pause';
      T.iv = setInterval(function () {
        var v = viewAng() + T.dir;
        if (v >= S.angle) { v = S.angle; T.dir = -1; }
        if (v <= 0) { v = 0; T.dir = 1; }
        S.view = v;
        render();
      }, 24);
    },
    openIt: function () { stopAnim(); S.view = S.angle; },
    closeIt: function () { stopAnim(); S.view = 0; },
    resetIt: function () { stopAnim(); S.view = null; },
    sheet: function () { sheet(); }
  };
  var T = { iv: null, dir: 1 };
  function stopAnim() {
    if (!T.iv) return;
    clearInterval(T.iv); T.iv = null;
    var b = document.getElementById('sx-anim'); if (b) b.innerHTML = '▶ Animate';
  }
  var NUM = { onPw: 'pw', onPh: 'ph', onPd: 'pd', onKg: 'kg', onAngle: 'angle',
              onView: 'view', onTilt: 'tilt', onKick: 'kickSet',
              onLidFrame: 'lidFrame', onLidFrameW: 'lidFrameW',
              onRail: 'rail' };

  function wire() {
    root.addEventListener('click', function (ev) {
      var el = ev.target.closest('[data-act]');
      if (!el || el.closest('template')) return;
      var act = el.getAttribute('data-act');
      if (ACT[act]) { ev.preventDefault(); ACT[act](); render(); return; }
      if (act === 'item.pick') {
        var row = el.closest('[data-list] > *');
        if (!row) return;
        if (row.__list === 'fittings') {
          // Set the end you are actually on. This used to flip to the tube end
          // the moment you picked a rod fitting, so the options changed under
          // your hand and the only way back was the toggle.
          var id = row.__row._id;
          if (S.end === 'rod') { S.rodFit = id; } else { S.tubeFit = id; }
        } else if (row.__list === 'brackets') {
          if (S.brkEnd === 'box') { S.bracketB = row.__row._id; }
          else { S.bracketA = row.__row._id; }
        } else if (row.__list === 'alts' || row.__list === 'lengths') {
          S.manual = row.__row._pick;
        }
        render();
      }
    });
    root.addEventListener('input', function (ev) {
      var el = ev.target.closest('[data-act]');
      if (!el) return;
      var k = NUM[el.getAttribute('data-act')];
      if (!k) return;
      S[k] = el.value === '' ? '' : Number(el.value);
      if (k === 'angle' && S.view != null && S.view > S.angle) S.view = S.angle;
      if (k !== 'view') S.manual = null;   // scrubbing is not a new choice
      render();
    });
    // Reconcile on blur, not on every keystroke. The number boxes take
    // anything typed or pasted, so without this one input could show three
    // different numbers at once - the box 99999, its slider 900, and the
    // solver 1200, which clamps to its own bounds rather than the UI's.
    //
    // Clamping during `input` instead would fight the typist: with a
    // minimum of 100, typing "5" on the way to "500" snaps to 100 and the
    // next keystroke reads 1005.
    root.addEventListener('change', function (ev) {
      var el = ev.target.closest('[data-act]');
      if (!el || el.type === 'range') return;
      var act = el.getAttribute('data-act');
      var k = NUM[act];
      if (!k) return;
      var rng = root.querySelector('input[type=range][data-act="' + act + '"]');
      if (!rng) return;
      var v = Number(el.value);
      if (el.value === '' || !isFinite(v)) { v = Number(rng.value); }
      var lo = Number(rng.min), hi = Number(rng.max);
      if (isFinite(lo)) { v = Math.max(lo, v); }
      if (isFinite(hi)) { v = Math.min(hi, v); }
      el.value = String(v);
      S[k] = v;
      render();
    });
    // Fig.02 drag to spin, as the design does it
    var c3 = document.getElementById('sx-ref3d');
    if (c3) {
      var x0 = 0, y0 = 0;
      // Pointer events, not mouse. A phone does not send mousemove during a
      // drag - it scrolls the page instead - so the 3D view could not be
      // spun on touch at all. Checked on a 375px viewport: a mouse drag
      // moved the canvas, a touch drag and a pointer drag both left it
      // byte-identical.
      //
      // pointer* is one path for mouse, touch and pen. The old mouse pair is
      // REPLACED rather than joined by it: a mouse drag fires both families,
      // so keeping both would run draw() twice per movement.
      c3.addEventListener('pointerdown', function (e) {
        x0 = e.clientX; y0 = S.yaw; S.drag = 1;
      });
      // On window, not the canvas, so the drag survives the pointer leaving
      // the box - same as the mousemove it replaces.
      window.addEventListener('pointermove', function (e) {
        if (!S.drag) return; S.yaw = y0 + (e.clientX - x0) * 0.012; draw();
      });
      var endSpin = function () { S.drag = null; };
      window.addEventListener('pointerup', endSpin);
      // A touch can be taken away by the browser - a scroll winning the
      // gesture, a call arriving - and that fires cancel, never up. Without
      // this the view stays stuck to a finger that is gone.
      window.addEventListener('pointercancel', endSpin);
    }
    var redraw = function () { draw(); };
    window.addEventListener('resize', redraw);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(redraw);
      ['sx-ref2d', 'sx-ref3d'].forEach(function (id) { var c = document.getElementById(id); if (c) ro.observe(c); });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(redraw);
  }


  // ── FITTING SHEET ─────────────────────────────────────────────────────────
  // The design's button does nothing. An installer at the bench wants three
  // things: where the brackets go, what the panel does through its travel, and
  // what to check when it is on. So the sheet draws the panel at four points
  // across the stroke, not one, and states the stroke each one is at.
  function sheet() {
    var V = vals(), positions = [0, 0.33, 0.66, 1];
    var SL = sweepMM();
    // 260 not 190. The box is sized from the headroom the open lid needs, so
    // a short frame squeezed it to 82px in a 300px canvas - the lid was the
    // right length for a box far too small.
    var w = 300, h = 260;
    // Drawn from st(), the same state the screen uses, with only the angle
    // changed per frame. This used to be a hand-rolled object with eight of
    // st()'s thirteen fields, and the five it left out are the ones you
    // notice: no lid rail, bracket A flat on the skin instead of on the
    // rail, no hand-over mark on the sweep, no LIFT arrow, and neither
    // bracket knowing its own type. Two places building the same state is
    // the bug; the missing fields were the symptom.
    var figBase = st();
    var figs = positions.map(function (f) {
      var ang = Math.round(S.angle * f);
      var cv = document.createElement('canvas');
      cv.width = w; cv.height = h;
      cv.style.width = w + 'px'; cv.style.height = h + 'px';
      // SXFIG sizes off clientWidth, which an offscreen canvas does not have,
      // so it is drawn in the document and read back as a data url.
      cv.style.position = 'fixed'; cv.style.left = '-9999px';
      document.body.appendChild(cv);
      var fs = {};
      for (var k in figBase) {
        if (Object.prototype.hasOwnProperty.call(figBase, k)) { fs[k] = figBase[k]; }
      }
      fs.ang = ang;
      SXFIG.draw2d(cv, fs);
      var url = cv.toDataURL('image/png');
      cv.remove();
      var ext = extAt(SL, ang);
      return { url: url, ang: ang, ext: ext };
    });

    // The mounting section, same state as the screen with only the canvas
    // size changed. On paper it runs the full width of the column.
    var mountUrl = (function () {
      var mc = document.createElement('canvas');
      mc.width = 760; mc.height = 300;
      mc.style.width = '760px'; mc.style.height = '300px';
      mc.style.position = 'fixed'; mc.style.left = '-9999px';
      document.body.appendChild(mc);
      var ms = {};
      for (var k in figBase) {
        if (Object.prototype.hasOwnProperty.call(figBase, k)) { ms[k] = figBase[k]; }
      }
      var url = '';
      try {
        SXFIG.drawMounts(mc, ms);
        url = mc.toDataURL('image/png');
      } catch (e) { url = ''; }
      mc.remove();
      return url;
    })();

    var rows = V.dims.map(function (d) {
      return '<tr><th>' + d.k + '</th><td>' + d.label + '</td><td class="v">' + d.val + '</td></tr>';
    }).join('');
    var spec = V.specs.map(function (s) {
      return '<tr><td>' + s.label + '</td><td class="v">' + s.val + '</td></tr>';
    }).join('');
    var cells = figs.map(function (f) {
      return '<figure><img src="' + f.url + '"><figcaption>' + f.ang + '\u00B0 \u00B7 '
        + f.ext + 'mm out</figcaption></figure>';
    }).join('');

    var win = window.open('', '_blank');
    if (!win) return;
    win.document.write('<!doctype html><meta charset="utf-8"><title>Struxa fitting sheet</title>'
      + '<style>'
      + 'body{font:13px/1.5 Assistant,Helvetica,sans-serif;color:#1c1e22;margin:28px;}'
      + 'h1{font-size:19px;margin:0 0 2px;text-transform:uppercase;letter-spacing:.04em;}'
      + '.sub{font:400 10px/1 "IBM Plex Mono",monospace;letter-spacing:.1em;'
      + 'text-transform:uppercase;color:#8a8a86;margin-bottom:18px;}'
      + '.figs{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;margin-bottom:18px;}'
      + 'figure{margin:0;border:1px solid #d6d6d2;}'
      + 'figure.mount{margin:0 0 16px;}'
      + 'figure.mount img{width:100%;display:block;}'
      + 'figure img{display:block;width:100%;}'
      + 'figcaption{font:500 9px/1 "IBM Plex Mono",monospace;letter-spacing:.06em;'
      + 'padding:5px 6px;border-top:1px solid #d6d6d2;color:#55555a;}'
      + 'table{border-collapse:collapse;width:100%;margin-bottom:16px;}'
      + 'th,td{border:1px solid #d6d6d2;padding:6px 8px;text-align:left;font-size:12px;}'
      + 'th{width:26px;background:#17171a;color:#fff;text-align:center;}'
      + 'td.v{font:500 12px "IBM Plex Mono",monospace;white-space:nowrap;width:84px;}'
      + 'h2{font:500 10px/1 "IBM Plex Mono",monospace;letter-spacing:.1em;'
      + 'text-transform:uppercase;color:#8a8a86;margin:0 0 7px;}'
      + '.note{border:1px solid #d6d6d2;border-left:3px solid #17171a;'
      + 'padding:8px 10px;margin-bottom:16px;font-size:12px;}'
      + '.note.warn{border-left-color:#c0392b;}'
      + '@media print{body{margin:12mm;} .figs{gap:6px;}}'
      + '</style>'
      + '<h1>Gas strut fitting sheet</h1>'
      + '<div class="sub">' + V.dimsLabel + ' \u00B7 ' + V.resultVariant + ' \u00B7 '
      + (S.struts === 2 ? 'two struts' : 'one strut')
      // Rails are box-lid only. On a window these two were printing
      // numbers that change nothing in the solve and whose sliders are
      // hidden, which reads as though they had been taken into account.
      + (S.type === 'Box Lid'
          ? ' \u00B7 lid frame ' + V.lidFrameLabel
            + ' \u00B7 frame rail ' + V.railLabel
          : '') + '</div>'
      + '<h2>Through the stroke</h2><div class="figs">' + cells + '</div>'
      + '<h2>Where the brackets go</h2><table>' + rows + '</table>'
      + '<div class="note' + (V.mountWarn ? ' warn' : '') + '">'
      + V.mountNote + '</div>'
      // The picture the A/B/C numbers refer to. Without it the sheet gives
      // three dimensions and no indication of which face they are measured
      // to, which is the question someone at the bench actually has.
      + (mountUrl
          ? '<h2>Which face each bracket bolts to</h2>'
            + '<figure class="mount"><img src="' + mountUrl + '"></figure>'
          : '')
      + '<h2>The strut</h2><table>' + spec + '</table>'
      + '<div class="sub" style="margin-top:14px">' + V.qtyLine + '</div>');
    win.document.close();
    // No auto win.print(). A modal print dialog fired on click hijacks the
    // tab the moment it opens - you cannot read the sheet before deciding
    // whether to print it, and it blocks the page until dismissed.
    win.focus();
  }


  // ── remembering what you typed ────────────────────────────────────────────
  // Every input reset on refresh. The rail was the one that got noticed,
  // because its default is None while the panel defaults to a 900x600 box
  // nobody had touched - but the whole box was being forgotten.
  //
  // The URL, not storage: a refresh keeps it and the configuration becomes
  // something you can send. Only values that differ from the default are
  // written, so an untouched page keeps a clean address.
  var KEEP = ['type', 'pw', 'ph', 'pd', 'kg', 'angle', 'struts', 'kickSet',
              'tilt', 'lidFrame', 'lidFrameW', 'lidClose', 'rail',
              'rodFit', 'tubeFit',
              'bracketA', 'bracketB',
              'qty', 'manual', 'end', 'brkEnd'];
  // Same limits the sliders carry. A URL is typed by anyone, so nothing comes
  // back in without being checked against them.
  var KEEP_RANGE = { pw: [200, 1500], ph: [150, 1200], pd: [100, 900],
                     kg: [0.5, 40], angle: [20, 90], kickSet: [0, 45],
                     tilt: [-30, 30], lidFrame: [0, 80], lidFrameW: [0, 80],
                     rail: [0, 120],
                     struts: [1, 2], qty: [1, 20] };
  var KEEP_ENUM = { type: ['Box Lid', 'Window'], end: ['rod', 'tube'],
                    lidClose: ['outside', 'inside'],
                    brkEnd: ['lid', 'box'],
                    bracketA: ['flat', 'offset'], bracketB: ['flat', 'offset'] };
  var KEEP_DEF = {};
  KEEP.forEach(function (k) { KEEP_DEF[k] = S[k]; });

  function restoreState() {
    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { return; }
    var fitIds = FITS.map(function (f) { return f.id; });
    KEEP.forEach(function (k) {
      if (!qs.has(k)) { return; }
      var raw = qs.get(k);
      if (k === 'rodFit' || k === 'tubeFit') {
        if (fitIds.indexOf(raw) >= 0) { S[k] = raw; }
        return;
      }
      if (KEEP_ENUM[k]) {
        if (KEEP_ENUM[k].indexOf(raw) >= 0) { S[k] = raw; }
        return;
      }
      if (k === 'manual') {
        var m = Number(raw);
        var P = window.SXPHYS;
        if (P && P.LENGTHS && P.LENGTHS.indexOf(m) >= 0) { S[k] = m; }
        return;
      }
      var r = KEEP_RANGE[k];
      var v = Number(raw);
      if (r && isFinite(v)) { S[k] = Math.max(r[0], Math.min(r[1], v)); }
    });
  }

  var _saveT = null, _lastQS = null;
  function saveState() {
    if (_saveT) { clearTimeout(_saveT); }
    // Debounced: render() runs on every frame of the animation, and the
    // address bar does not need to hear about the view angle.
    _saveT = setTimeout(function () {
      _saveT = null;
      try {
        // Start from what is already in the URL, not from empty. Building a
        // fresh URLSearchParams discards every parameter this calculator did
        // not put there - and one of those is ?view=, which is what serves
        // this page at all. The sequence was: open the page, move a slider,
        // saveState rewrites the address bar without ?view=, reload, and the
        // calculator is gone because the bare URL renders the gate. A
        // bookmark taken after touching anything was already broken.
        //
        // Deleting the KEEP keys first still gives a clean canonical set and
        // drops any that have returned to their default, so the only
        // behaviour change is that foreign parameters survive.
        var qs;
        try { qs = new URLSearchParams(window.location.search); }
        catch (e) { qs = new URLSearchParams(); }
        KEEP.forEach(function (k) { qs.delete(k); });
        KEEP.forEach(function (k) {
          if (S[k] == null || S[k] === KEEP_DEF[k]) { return; }
          // A half-typed or pasted value must not reach the address bar.
          // restoreState already rejects out-of-range values on the way back
          // in, so this was never unsafe - but ?pd=99999&kg=100000&pw= is
          // not a link anyone should be handed.
          var r = KEEP_RANGE[k];
          if (r) {
            var v = Number(S[k]);
            if (!isFinite(v) || v < r[0] || v > r[1]) { return; }
          }
          qs.set(k, S[k]);
        });
        var s = qs.toString();
        if (s === _lastQS) { return; }
        _lastQS = s;
        window.history.replaceState(null, '',
          window.location.pathname + (s ? '?' + s : ''));
      } catch (e) { /* no history api, or a sandboxed frame */ }
    }, 400);
  }

  function boot() {
    root = document.getElementById('gsc');
    if (!root || !window.SXFIG) return;
    restoreState();
    wire();
    render();
    // the design re-measures for a few beats after load, because fonts and
    // layout settle late and the canvases size off their own box
    var n = 0, iv = setInterval(function () { draw(); if (++n > 8) clearInterval(iv); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
